import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [offers, setOffers] = useState([]);

  const loadSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
  }, []);

  const loadOffers = useCallback(async () => {
    const { data } = await api.get("/offers", { params: { active_only: true } });
    setOffers(data);
  }, []);

  useEffect(() => {
    loadSettings();
    loadOffers();
  }, [loadSettings, loadOffers]);

  // Live-apply brand identity (title, favicon, OG) whenever settings change.
  useEffect(() => {
    if (!settings) return;
    if (settings.brand_name) document.title = `${settings.brand_name} — ${settings.tagline || "Jewellery"}`;
    const setLink = (rel, href) => {
      let l = document.querySelector(`link[rel="${rel}"]`);
      if (!l) { l = document.createElement("link"); l.rel = rel; document.head.appendChild(l); }
      l.href = href;
    };
    if (settings.favicon) { setLink("icon", settings.favicon); setLink("apple-touch-icon", settings.favicon); }
    const setMeta = (prop, val) => {
      let m = document.querySelector(`meta[property="${prop}"]`);
      if (!m) { m = document.createElement("meta"); m.setAttribute("property", prop); document.head.appendChild(m); }
      m.setAttribute("content", val);
    };
    if (settings.og_image) setMeta("og:image", settings.og_image);
    if (settings.brand_name) setMeta("og:title", `${settings.brand_name} — ${settings.tagline || ""}`);
  }, [settings]);

  return (
    <StoreContext.Provider value={{ settings, offers, loadSettings, loadOffers }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
